import { Navigate, Outlet } from 'react-router-dom';

import { useEffect } from 'react';

import { useAuth } from './AuthContext';

export const ProtectedRoutes = () => {
    const { auth, claims, signOutUser } = useAuth();

    useEffect(() => {
        if (auth.currentUser && !claims?.admin) {
            signOutUser();
        }
    }, [ auth.currentUser, claims, signOutUser ]);

    return (
        auth.currentUser && claims?.admin ?
            <Outlet /> :
            <Navigate to="/" />
    );
}